<template minapp='mpx' xlang='wxml'>
  <view class='es-checkbox custom-class' role='checkbox' wx:style="{{fontSizeStyle}}">
    <view 
    class="es-checkbox__label label-class" 
    wx:if="{{labelPosition === 'left'}}"
    bindtap="onClickLabel"
    >
      <text wx:if="{{label}}">{{label}}</text>
      <slot wx:else />
    </view>
    <view 
    class="es-checkbox__icon icon-class" 
    wx:class="{{classnames}}"
    wx:style="{{iconStyle}}"
    bindtap="onChange"
    >
      <slot name='icon' wx:if="{{useIconSlot}}" />
      <es-icon 
      wx:else
      size='{{iconSize}}'
      name="{{nameIcon}}" 
      wx:style="{{checkedColor}}"
      />
    </view>
    <view 
    class="es-checkbox__label label-class" 
    wx:if="{{labelPosition === 'right'}}"
    bindtap="onClickLabel"
    >
      <text wx:if="{{label}}">{{label}}</text>
      <slot wx:else />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import checkboxGroup from '../checkbox-group/index?resolve'
  createComponent({
    parent: checkboxGroup,
    externalClasses: ['label-class', 'icon-class', 'custom-class'],
    props: {
      useIconSlot: Boolean,
      iconSize: {
        type: Number,
        value: 14
      },
      color: String,
      labelPosition: {
        type: String,
        value: 'right'
      },

      shap: {
        type: String,
        value: 'square'
      },
      fontSize:{
        type: Number
      },
      label: String,
      name: null,
      nameIcon: {
        type: String,
        value: 'check'
      },
      value: null,
      disabled: Boolean,
      iconStyle: null
    },

    computed: {
      parent() {
        return this.$ancestor('CheckboxGroup')
      },
      isReadOnly() {
        const { disabled } = this.parent || {}
        return disabled || this.disabled;
      },
      checkedColor() {
        const { color } = this
        if (!color) {
          return
        }

        return {
          borderColor: color,
          backgroundColor: color
        }
      },

      classnames() {
        const { shap, name } = this
        const { value } = this.parent || this
        return {
          'es-checkbox--disabel':  this.isReadOnly,
          'es-checkbox--checked': !this.isReadOnly && (Array.isArray(value) ? value.includes(name) : !!value),
          [`es-checkbox--${shap}`]: true
        }
      },

      fontSizeStyle() {
        return {
          fontSize: (this.fontSize || this.iconSize) + 'px'
        }
      }
    },

    methods: {
      onChange() {
        const parent = this.parent
        const { value } = parent || this
        const val = Array.isArray(value) ? value.includes(this.name) : value
        if (this.isReadOnly) {
          return
        }

        if (parent) {

          this.emitParent(parent, !val)
        } else {
          this.emit(this, !val)
        }
      },

      emit(target, value) {
        const detail = { value }
        this.$trigger('change', detail)
        target.$trigger('input', detail)
        target.$trigger('change', detail)
      },

      onClickLabel() {
        if (!this.isReadOnly) {
          this.onChange()
          this.$trigger('click-label')
        }
      },

      emitParent(target, val) {
        const { max, value } = target
        const parentValue = value.slice()
        const { name } = this
        if (val) {
          if (max && parentValue.length >= max) {
            this.$trigger('warning')
            return
          }

          if (parentValue.indexOf(name) === -1) {
            parentValue.push(name)
            this.emit(target, parentValue)
          }
        } else {
          const index = parentValue.indexOf(name)
          if (index !== -1) {
            parentValue.splice(index, 1)
            this.emit(target, parentValue)
          }
        }
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '../icon/index'
    }
  }
</script>

